export default __webpack_public_path__ + "static/media/flutter2.1eabc38a.webp";